import styled from "styled-components";

export const SubSection = styled.div`
  margin-bottom: 2rem;
`;

export const Title = styled.div`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.colorSix};
`;
